import { createRoot } from "react-dom/client";
import { platform } from "./platform";
import { App } from "./ui/App";
import { unlockAudioOnTap } from "./ui/cues";
import "./styles.css";

platform.setupAudioSession();
platform.persistStorage();
unlockAudioOnTap();

createRoot(document.getElementById("root")!).render(<App />);
